import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import ApaarProtectedRoute from "./ApaarProtectedRoute";
import { ProtectedRoute } from "@gyandiksha/shared-ui/routes";
import { PageNotFound } from "@repo/design-system/components/ui";


const Authentication = React.lazy(() => import("../pages/authentication/Authentication"));

const AppRoutes = () => {
    return (
        <Router>
            {/* <Suspense fallback={<PageLoader />}> */}
            <Routes>
                <Route path="/portal-selection" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />
                {/* Profile & Settings (shared @gyandiksha/profile pages) */}
                <Route exact name="Profile" path="/profile" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />
                <Route exact name="EditProfile" path="/edit-profile" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />
                <Route exact name="Settings" path="/settings" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />
                <Route exact name="Login" path="/" element={<Authentication />} />
                <Route exact name="Login" path="/login" element={<Authentication />} />
                <Route exact name="Registration" path="/registration" element={<Authentication />} />
                <Route exact name="ForgotPassword" path="/forgot-password" element={<Authentication />} />
                <Route exact name="DigiLockerPasswordSetup" path="/digilocker-password-setup" element={<Authentication />} />

                {/* Student Registration */}

                <Route exact name="StudentRegistration" path="/student-registration" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />
                <Route exact name="StudentRegistrationReview" path="/student-registration-review" element={
                    <ApaarProtectedRoute>
                        <Authentication />
                    </ApaarProtectedRoute>
                } />

                <Route exact name="apperVerification" path="/apaar-verification" element={
                    <ProtectedRoute>
                        <Authentication />
                    </ProtectedRoute>
                } />

                <Route exact name="comingSoon" path="/coming-soon" element={
                    <ProtectedRoute>
                        <Authentication />
                    </ProtectedRoute>
                } />

                <Route path="*" element={<PageNotFound />} />
            </Routes>
            {/* </Suspense> */}
        </Router >
    );
};

export default AppRoutes;
